var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trademark"},[_vm._v(" Siemens Energy is a trademark licensed by Siemens AG."),_c('br'),_vm._v(" © Siemens Energy, 2025 ")])}]

export { render, staticRenderFns }